<ng-select
        class="custom"
        #select
        [items]="entries$ | async"
        bindLabel="name"
        [trackByFn]="trackByFn"
        [minTermLength]="3"
        [loading]="loading"
        [formControl]="formControl"
        placeholder="{{'label.project' | translate}}"
        typeToSearchText="Digita almeno 3 caratteri"
        [typeahead]="input$"
        [readonly]="_readonly"
        (change)="onInput($event)"
        (blur)="onTouched()"
        >

  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.name }}
<!--
      - <small>{{ item.data.code }} <b> {{ item.data.vatId ? '| ' + item.data.vatId : '' }}</b></small>
-->
    </div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div>{{ item.name }}</div>
<!--
    <small>{{ item.data.code }}<b> {{ item.data.vatId ? '| ' + item.data.vatId : '' }}</b></small>
-->
  </ng-template>
</ng-select>